function createPopup(url, title) {
  var strTitle = title
  var screenLeft = window.screenLeft
  var screenTop = window.screenTop
  var width = window.innerWidth
  var height = window.innerHeight
  var left = width / 2 - 500 / 2 + screenLeft
  var top = height / 2 - 400 / 2 + screenTop
  var strParam = `width=500,height=400,resizable=no,top=${top},left=${left}`

  window.open(url, strTitle, strParam).focus()
}

$(document).ready(function() {
  $('.share-popup').on('click', function(e) {
    e.preventDefault()
    createPopup($(this).attr('href'))
  })

  var timeout = false

  $('.article-share-copy-anchor').on('click', function() {
    clearTimeout(timeout)

    $(this).addClass('active')

    const textarea = document.getElementById('share-textarea')
    textarea.select()
    document.execCommand('copy')

    timeout = setTimeout(() => {
      $(this).removeClass('active')
    }, 2000)
  })
})
